<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogFormVisible"
    width="600px"
    top="2vh"
    @close="close"
  >
    <el-form
      v-if="dialogFormVisible"
      ref="form"
      :model="form"
      :rules="rules"
      label-width="95px"
    >
      <!-- 所属用户 -->
      <el-form-item label="所属用户">
        <div style="display: flex; align-items: center">
          <el-select
            ref="select"
            v-model="form.uid"
            style="width: 300px"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            @focus="clear"
            @hook:mounted="clear"
            @visible-change="clear"
            @change="getInfo"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="`${item.nickname} （${item.code ? item.code+'/'+item.ydm_code+'/'+item.ydr_code: '-'}）`"
              :value="item.id"
            />
          </el-select>
          <el-button
            type="primary"
            size="mini"
            style="margin-left: 15px"
            @click="clearUserInfo"
          >
            清除历史记录
          </el-button>
          <!--
          <el-popover v-model="popoverVisible" placement="top" width="160">
            <p>确定清除库位？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="popoverVisible = false">
                取消
              </el-button>
              <el-button type="primary" size="mini" @click="confirmClear">
                确定
              </el-button>
            </div>
          </el-popover>
          <el-button
            v-if="form.storage_location"
            type="primary"
            size="mini"
            style="margin-left: 15px"
            @click="clearKuwei"
          >
            清除库位
          </el-button>
          -->
        </div>
      </el-form-item>

      <!-- 所属状态 -->
      <el-form-item label="所属状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 线路 -->
      <el-form-item label="线路" prop="status">
        <el-select v-model="form.kor_type" placeholder="请选择" @change="lineChange">
          <el-option
            v-for="item in countryList"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          />
        </el-select>
      </el-form-item>

      <!-- 所属库位 -->
      <el-form-item label="所属库位" prop="storage_location">
        <el-select v-model="form.storage_location" filterable placeholder="请选择">
          <el-option
            v-for="item in kuweiList"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
        <el-button
          type="primary"
          style="margin-left: 15px"
          @click="copy(form.storage_location)"
        >
          复制库位号
        </el-button>
      </el-form-item>

      <!-- 仓库所在区 -->
      <el-form-item v-if="showCangku" label="仓库所在区" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- 超时的仓储费 -->
      <el-form-item label="仓储费用">
        <el-input
          v-model="form.storage_price"
          maxlength="6"
          show-word-limit
          autocomplete="off"
          @input="form.storage_price = $geShi(form.storage_price)"
        />
      </el-form-item>

      <!-- 原包裹单号 -->
      <el-form-item v-if="korShow" label="原包裹单号" prop="old_kr_code">
        <el-input v-model.trim="form.old_kr_code" autocomplete="off" />
      </el-form-item>

      <!-- 包裹单号 -->
      <el-form-item label="包裹单号" prop="code">
        <el-input
          v-if="title == '添加'"
          v-model.trim="form.code"
          autocomplete="off"
        />
        <el-input
          v-else
          v-model.trim="form.code"
          :disabled="isShowCode"
          autocomplete="off"
        />
      </el-form-item>

      <!-- 运单号 -->
      <el-form-item label="运单编号" prop="express_code">
        <el-input
          v-model.trim="form.express_code"
          maxlength="25"
          show-word-limit
          autocomplete="off"
        />
      </el-form-item>

      <!-- 重量 -->
      <el-form-item label="订单重量" prop="weight">
        <el-input
          v-model.trim="form.weight"
          maxlength="8"
          show-word-limit
          autocomplete="off"
          @input="handleInputWeight"
        />
      </el-form-item>

      <!-- 价格 -->
      <el-form-item label="订单价格" prop="price">
        <el-input
          v-model.trim="form.price"
          maxlength="8"
          show-word-limit
          autocomplete="off"
          @input="handleInputPrice"
        />
      </el-form-item>

      <!-- 收货人 -->
      <el-form-item label="收货人" prop="name">
        <el-input
          v-model.trim="form.name"
          maxlength="15"
          show-word-limit
          autocomplete="off"
          @input="handleInputPrice"
        />
      </el-form-item>

      <!-- 收货人电话 -->
      <el-form-item label="收货人电话" prop="phone">
        <el-input
          v-model.trim="form.phone"
          maxlength="11"
          show-word-limit
          autocomplete="off"
          @input="handleInputPrice"
        />
      </el-form-item>

      <!-- 身份证号 -->
      <el-form-item label="身份证号" prop="idcode">
        <el-input
          v-model.trim="form.idcode"
          maxlength="18"
          show-word-limit
          autocomplete="off"
          @input="handleInputPrice"
        />
      </el-form-item>

      <!-- 收货地址 -->
      <el-form-item label="收货地址" prop="price">
        <el-cascader
          :placeholder="cityText"
          :props="cascaderProps"
          @change="chooseCity"
        />
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注" prop="remark2">
        <el-input
          v-model.trim="form.remark2"
          maxlength="80"
          show-word-limit
          autocomplete="off"
        />
      </el-form-item>

      <!-- 详细地址 -->
      <el-form-item label="详细地址" prop="address">
        <el-input
          v-model.trim="form.address"
          maxlength="50"
          show-word-limit
          autocomplete="off"
        />
      </el-form-item>

      <!-- 产品图片 -->
      <el-form-item label="包裹图片" prop="pic">
        <uploadFile
          :limit="1"
          :img-list-string="form.pic"
          @fileChange="uploadChange($event, 'pic')"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { orderDetail, memberListAll, orderUpdate, ordergetEnableLocation, orderGetAllStorageLocation, Index_country_list } from '@/api/xgcApi'
import { getUploadUrl } from '@/config'
import uploadFile from '@/components/uploadFile'
import CitySelection from '@/components/CitySelection'
import { goodsAdd, index_city } from '../../../api/xgcApi'
import { number } from 'echarts'

export default {
  name: 'UserManagementEdit',
  components: {
    uploadFile,
    CitySelection,
  },
  data() {
    return {
      // ==================== 基础数据 ====================
      orderRow: null, // 选中包裹详情
      countryList: [], // 线路列表
      loading: false, // 加载状态
      popoverVisible: false, // 弹窗显示状态
      
      // ==================== 表单数据 ====================
      form: this.getDefaultForm(),
      dialogFormVisible: false,
      clearStorageLocation: '1',
      
      // ==================== 下拉选项 ====================
      options: [], // 用户选项
      kuweiList: [], // 库位选项
      typeList: [
        { label: '韩区包裹', value: 1 },
        { label: '日区包裹', value: 2 },
      ],
      statusList: [
        { value: 0, label: '未入库' },
        { value: 1, label: '已入库' },
        { value: 2, label: '待审核' },
        { value: 3, label: '待打包' },
        { value: 4, label: '待发货' },
        { value: 5, label: '待支付' },
        { value: 6, label: '转运中' },
        { value: 7, label: '已签收' },
        { value: 8, label: '已拒绝' },
        { value: 10, label: '暂存' },
        { value: 11, label: '退款中' },
        { value: 12, label: '已退款' },
      ],
      
      // ==================== 级联选择器配置 ====================
      cascaderProps: {
        lazy: true,
        lazyLoad: this.getCityList,
      },
      
      // ==================== 界面控制 ====================
      title: '',
      isShowCode: false,
      korShow: false,
      showCangku: false,
      cityText: '-',
      
      // ==================== 验证规则 ====================
      rules: {
        type: [{ required: true, trigger: 'blur', message: '请选择仓库所在区' }],
        code: [{ required: true, trigger: 'blur', message: '请输入包裹单号' }],
        uid: [{ required: true, trigger: 'change', message: '请选择所属用户' }],
      },
    }
  },
  
  mounted() {
    this.getTypeList()
  },
  
  methods: {
    // ==================== 表单默认值 ====================
    /**
     * 获取表单默认值
     */
    getDefaultForm() {
      return {
        id: null,
        uid: '',
        status: '',
        type: null,
        kor_type: null,
        storage_location: null,
        storage_price: null,
        old_kr_code: null,
        code: null,
        express_code: null,
        weight: null,
        price: null,
        name: null,
        phone: null,
        idcode: null,
        province: null,
        city: null,
        area: null,
        address: null,
        remark2: null,
        pic: null,
        userInfo: null,
      }
    },

    /**
     * 重置表单数据
     * @param {boolean} keepFields - 是否保留部分字段（如类型）
     */
    resetForm(keepFields = false) {
      const defaultForm = this.getDefaultForm()
      
      if (keepFields) {
        // 保留特定字段
        const preserved = {
          type: this.form.type,
          kor_type: this.form.kor_type,
        }
        this.form = { ...defaultForm, ...preserved }
      } else {
        this.form = { ...defaultForm }
      }
      
      // 重置其他状态
      this.clearStorageLocation = '1'
      this.korShow = false
      this.isShowCode = false
      this.cityText = '-'
      this.options = []
      this.kuweiList = []
      
      // 重置表单验证
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
        this.$refs['form'].clearValidate()
      }
    },

    // ==================== 弹窗操作 ====================
    /**
     * 关闭弹窗
     */
    close() {
      this.resetForm()
      this.dialogFormVisible = false
      this.$emit('close')
    },

    /**
     * 初始化弹窗数据
     * @param {Object} row - 行数据
     * @param {number} row.country - 国家类型 1=韩国 2=日本
     */
    async showEdit(row) {
      console.log(row, '订单详情')
      this.orderRow = row
      this.loading = true

      try {
        // 重置表单，但保留类型字段
        this.resetForm(true)
        
        // 根据 country 类型决定是添加还是编辑
        const isAdd = row.country === 1 || row.country === 2
        
        if (isAdd) {
          await this.initAddMode(row)
        } else {
          await this.initEditMode(row)
        }
        
        this.dialogFormVisible = true
      } catch (error) {
        console.error('初始化弹窗数据失败:', error)
        this.$message.error('数据加载失败，请重试')
        this.close()
      } finally {
        this.loading = false
      }
    },

    /**
     * 初始化添加模式
     */
    async initAddMode(row) {
      this.title = '添加'
      this.form.type = String(row.country) // 1=韩国, 2=日本
      
      // 从缓存加载用户信息
      this.loadFromCache()
      
      // 获取用户列表
      await this.getUserInfo()
      
      // 获取库位列表（仅韩国需要）
      if (row.country === 1) {
        await this.getAllKuweiList()
      }
    },

    /**
     * 初始化编辑模式
     */
    async initEditMode(row) {
      this.title = '订单编辑'
      this.korShow = true
      
      // 设置基础信息
      this.form.type = row.type
      this.form.kor_type = row.kor_type || null
      
      // 判断是否可编辑包裹单号
      const readOnlyStatuses = [4, 5, 6, 7, 10]
      this.isShowCode = readOnlyStatuses.includes(row.status)
      
      // 获取订单详情
      const { data } = await orderDetail({ id: row.id })
      
      // 合并数据
      this.form = {
        ...this.form,
        ...data,
      }
      
      // 设置地址显示
      if (data.province_name) {
        this.cityText = `${data.province_name}/${data.city_name}/${data.area_name}`
      }
      
      // 设置用户信息
      if (data.userInfo) {
        this.form.uid = data.userInfo.id || ''
        this.form.userInfo = data.userInfo
      }
      
      // 获取用户列表
      await this.getUserInfo()
      
      // 获取库位列表
      await this.getAllKuweiList()
      
      // 处理 type 为 0 的情况
      if (this.form.type === 0) {
        this.form.type = null
      }
    },

    // ==================== 线路相关 ====================
    /**
     * 线路切换
     */
    lineChange(index) {
      this.getAllKuweiList()
    },

    /**
     * 获取线路列表
     */
    getTypeList() {
      Index_country_list({}).then(res => {
        this.countryList = res.data
      })
    },

    // ==================== 库位相关 ====================
    /**
     * 复制文本到剪贴板
     */
    copy(text) {
      if (text) {
        const textarea = document.createElement('textarea')
        textarea.value = text
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        this.$message({
          type: 'success',
          message: '复制成功!'
        })
      } else {
        this.$message({
          type: 'info',
          message: '暂无可复制内容!'
        })
      }
    },

    /**
     * 获取库位列表（启用状态）
     */
    async getKuweiList(params = {}) {
      try {
        const { data } = await ordergetEnableLocation(params)
        this.kuweiList = data
      } catch (error) {
        console.error('获取库位列表失败:', error)
        this.kuweiList = []
      }
    },

    /**
     * 获取全部库位列表
     */
    async getAllKuweiList(params = {}) {
      const requestData = {
        ...params,
        kor_type: this.form.kor_type,
      }
      
      try {
        const { data } = await orderGetAllStorageLocation(requestData)
        this.kuweiList = data.map(item => item.store_number)
      } catch (error) {
        console.error('获取库位列表失败:', error)
        this.kuweiList = []
      }
    },

    /**
     * 点击清空库位
     */
    clearKuwei() {
      this.popoverVisible = true
    },

    /**
     * 确认清空库位
     */
    confirmClear() {
      this.clearStorageLocation = '2'
      this.popoverVisible = false
    },

    // ==================== 地址相关 ====================
    /**
     * 选择城市
     */
    chooseCity(e) {
      this.form.province = e[0]
      this.form.city = e[1]
      this.form.area = e[2]
    },

    /**
     * 获取省市区列表（级联懒加载）
     */
    getCityList(node, resolve) {
      const { level, data } = node
      const gid = data ? data.value : 0
      
      index_city({ pid: gid }).then((res) => {
        const nodes = Array.from(res.data, (item) => ({
          value: item.code,
          label: item.name,
          leaf: level >= 2,
        }))
        resolve(nodes)
      })
    },

    // ==================== 用户相关 ====================
    /**
     * 清除用户历史记录
     */
    clearUserInfo() {
      localStorage.setItem('userUid', null)
      localStorage.setItem('userInfo', null)
      this.form.uid = null
    },

    /**
     * 解决移动端点击不显示键盘问题
     */
    clear(async) {
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题
          setTimeout(() => {
            const { select } = this.$refs
            if (select) {
              const input = select.$el.querySelector('.el-input__inner')
              if (input) {
                input.removeAttribute('readonly')
              }
            }
          }, 200)
        }
      })
    },

    /**
     * 远程搜索用户
     */
    remoteMethod(e) {
      this.page = 1
      this.limit = 20
      const data = {
        nickname: e,
        page: 1,
        limit: 100,
      }
      memberListAll(data).then(({ data }) => {
        this.options = data
      })
    },

    /**
     * 获取选中的用户信息
     */
    getInfo(value) {
      this.options.forEach((item) => {
        if (value === item.id) {
          localStorage.setItem('userUid', item.id)
          localStorage.setItem('userInfo', JSON.stringify(item))
        }
      })
    },

    /**
     * 获取用户列表
     */
    async getUserInfo(params = {}) {
      const requestData = {
        ...params,
        page: 1,
        limit: 100,
      }
      
      try {
        const { data } = await memberListAll(requestData)
        
        // 如果当前有选中的用户，确保在列表中
        if (this.form.userInfo) {
          const exists = data.some(item => 
            item.code === this.form.userInfo.code
          )
          if (!exists) {
            data.push(this.form.userInfo)
          }
        }
        
        this.options = data
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.options = []
      } finally {
        this.loading = false
      }
    },

    /**
     * 从本地缓存加载用户信息
     */
    loadFromCache() {
      const userUid = localStorage.getItem('userUid')
      const userInfo = localStorage.getItem('userInfo')
      
      if (userUid && userInfo && userUid !== 'null' && userInfo !== 'null') {
        this.form.uid = Number(userUid)
        this.form.userInfo = JSON.parse(userInfo)
      } else {
        this.form.uid = ''
        this.form.userInfo = null
      }
    },

    // ==================== 输入校验 ====================
    /**
     * 重量输入校验
     */
    handleInputWeight() {
      this.form.weight = this.form.weight
        .replace(/[^\d.]/g, '')
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },

    /**
     * 价格输入校验
     */
    handleInputPrice() {
      this.form.weight = this.form.weight
      this.form.price = this.form.price
        .replace(/[^\d.]/g, '')
        .replace(/^(\d*\.)(.*)\./g, '$1$2')
        .replace(/^0+(\d+\.{0,1}\d*)/, '$1')
    },

    // ==================== 图片上传 ====================
    /**
     * 上传图片回调
     */
    uploadChange(e) {
      let strurl = e.join(',')
      strurl = strurl.replace(/\\\\/g, '//')
      strurl = strurl.replace(/\\/g, '/')
      this.form.pic = strurl
    },

    // ==================== 提交保存 ====================
    /**
     * 保存表单
     */
    save() {
      const submitData = {
        id: this.form.id,
        uid: this.form.uid || null,
        type: this.form.type,
        status: this.form.status || '',
        pic: this.form.pic,
        code: this.form.code,
        express_code: this.form.express_code,
        weight: this.form.weight,
        price: Number(this.form.price),
        province: this.form.province,
        city: this.form.city,
        area: this.form.area,
        address: this.form.address,
        name: this.form.name,
        phone: this.form.phone,
        idcode: this.form.idcode,
        remark2: this.form.remark2,
        clear_storage_location: this.clearStorageLocation,
        storage_location: this.form.storage_location,
        old_kr_code: this.form.old_kr_code,
        storage_price: this.form.storage_price,
        kor_type: this.form.kor_type,
      }

      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          try {
            const { data, msg } = await orderUpdate(submitData)
            this.$baseMessage(msg, 'success')
            this.$emit('fetch-data')
            this.clearStorageLocation = '1'
            this.close()
          } catch (error) {
            console.error('保存失败:', error)
            this.$message.error('保存失败，请重试')
          }
        }
        return false
      })
    },
  },
}
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>